export default __webpack_public_path__ + "static/media/assistance-chat-background.ca031987.png";